export const API_UNTRACKED_CALLS = 'calls/tracker/untracked-calls';
export const API_UNTRACKED_CALLS_COUNT = 'tracker/untracked-calls/count';
export const API_UNTRACKED_CALL_CALL_RECORD = (callId: string) =>
  `${API_UNTRACKED_CALLS}/${callId}/call-record`;
export const API_UPDATE_UNTRACKED_CALL = (guid: string) =>
  `${API_UNTRACKED_CALLS}/${guid}`;
export const API_CLEAR_UNTRACKED_CALL = (guid: string) =>
  `${API_UNTRACKED_CALLS}/${guid}/hide`;
export const API_SPLIT_CALL = 'calls/management/split-calls';
export const API_SPLIT_CALL_LIST = 'calls/management/split-calls';
export const API_CALL_TRANSCRIBE_DOWNLOAD_LINK =
  'calls/transcript/download-link';
